<div class="layout">
  @if (isLoggedIn) {
    <!-- Window with timer and option to logout or stay -->
    <app-modal-stay></app-modal-stay>
    @if (show.sideNav) {
      <app-side-nav/>
    }
    @if (show.horNav) {
      <app-horizontal-nav-bar [class.hor-nav-to-the-left]="!show.sideNav" />
    }
  }

  <main [ngClass]="{ 'mt-[4.4rem]': show.horNav, 'ml-[4.4rem]': show.sideNav }">
    <app-spinner/>
    <app-unsaved-changes-modal-wrapper></app-unsaved-changes-modal-wrapper>
    <router-outlet></router-outlet>
  </main>

  <app-notification></app-notification>
</div>
